import styles from './realizations.module.scss';
import {useEffect, useState} from "react";
import {Button} from "../../components/Button/Button";
import "keen-slider/keen-slider.min.css";
import {useKeenSlider} from "keen-slider/react";

export const Realizations = () => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = Array.from({length: 24}, (_, i) => require(`./images/${i + 1}.jpg`));

  const [popupSliderRef, popupSlider] = useKeenSlider({
    loop: true,
    origin: "center",
    slides: {perView: 2.5, spacing: 2},
    initial: currentIndex,
    breakpoints: {
      "(max-width: 1200px)": {
        slides: {perView: 1, spacing: 10},
      },
    },
  });

  const openPopup = (index) => {
    setCurrentIndex(index);
    setPopupOpen(true);
  };

  useEffect(() => {
    if (popupOpen && popupSlider) {
      popupSlider.current.moveToIdx(currentIndex);
    }
  }, [popupOpen, currentIndex, popupSlider]);

  const closePopup = () => setPopupOpen(false);


  return <section id="realizations" className={styles.realizations}>
    <div className={"container"}>
      <h2>ostatnie realizacje</h2>
      <div className={styles.grid}>
        <div>
          {images.map((src, index) => (
              <div key={index} className={styles.imageWrapper} onClick={() => openPopup(index)}>
                <img key={index} src={src} alt={`Obrazek ${index + 1}`}/>
              </div>
          ))}
        </div>
      </div>
      <div className={styles.center}>
        <a href={"https://www.instagram.com/toporgarage.pl"} target="_blank" rel="noreferrer"
           className={styles.buttonA}><Button>Sprawdź nasz instagram</Button></a>
      </div>
      {/* Popup */}
      {popupOpen && (
          <div className={styles.popupOverlay} onClick={closePopup}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
              <div ref={popupSliderRef} className="keen-slider">
                <div className={styles.closeDiv}>
                  <button className={styles.closeBtn} onClick={closePopup}><span></span><span></span></button>
                </div>
                {images.map((src, index) => (
                    <div key={index} className="keen-slider__slide">
                      <img src={src} alt={`Obrazek ${index + 1}`} className={styles.popupImage}/>
                    </div>
                ))}
              </div>
            </div>
          </div>
      )}
    </div>
  </section>
}